class HeaderSwipe {

    constructor($hero) {
        this.updateSize = this.updateSize.bind(this);

        this.$hero = $hero;
        let $canvas = $hero.find("canvas");
        this.$canvas = $canvas;
        this.canvas = $canvas[0];
        this.$text = $hero.find("h1");


        this.vertices = [];
        this.waypoints = [];

        this.progress = 0;

        this.updateSize();
        this.bindEvents();

        $hero.find(".hero__text").addClass("hero__text--canvas-ready");
    }

    generatePoints() {
        this.vertices = [];
        this.waypoints = [];

        let width = this.contentWidth * 1.16;
        let height = this.contentHeight * 1.32;
        let offsetWidth = (width / HeaderSwipe.STROKE_COUNT) / 2;
        let leftOffset = this.contentLeft - (this.contentWidth * 0.09);
        let topOffset = this.contentTop - (this.contentHeight * 0.16);

        for (let x = 0; x <= HeaderSwipe.STROKE_COUNT * 2; x++) {
            this.vertices.push({
                x: leftOffset + (offsetWidth * x),
                y: (x % 2) === 0 ? topOffset : topOffset + height
            })
        }

        for (let i = 1; i < this.vertices.length; i++) {
            let lastVertex = this.vertices[i - 1];
            let currentVertex = this.vertices[i];
            let dx = currentVertex.x - lastVertex.x;
            let dy = currentVertex.y - lastVertex.y;
            for (let j = 0; j < HeaderSwipe.WAYPOINT_COUNT; j++) {
                let x = lastVertex.x + dx * j / HeaderSwipe.WAYPOINT_COUNT;
                let y = lastVertex.y + dy * j / HeaderSwipe.WAYPOINT_COUNT;
                this.waypoints.push({
                    x: x,
                    y: y
                });
            }
        }
    }

    bindEvents() {
        $(window).on("resize", this.updateSize);
    }

    updateSize() {
        this.$canvas.attr("width", this.$canvas.outerWidth());
        this.$canvas.attr("height", this.$canvas.outerHeight());

        this.fontStyle = ['font-style', 'font-variant', 'font-weight', 'font-size', '/', 'line-height', 'font-family'].map((prop) => prop === '/' ? '/' : this.$text.css(prop)).join(" ");

        this.fontHeight = parseInt(this.$text.css("line-height"));

        this.context = this.canvas.getContext('2d');

        this.contentWidth = this.getContentWidth();
        this.contentHeight = this.getContentHeight();
        this.contentLeft = this.getContentLeft();
        this.contentTop = this.getContentTop();

        this.generatePoints();

        this.context.lineWidth = this.getLineWidth();

        this.render();
    }

    render(forced = true) {
        let ctx = this.context;
        ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

        //Text
        ctx.font = this.fontStyle;
        ctx.fillStyle = '#fff';
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        ctx.lineCap = 'square';

        let windowWidth = $(window).width();

        ctx.fillText(this.$text.text(), windowWidth / 2, this.$text.offset().top + this.fontHeight / 2);

        if (this.waypoints.length > 0) {
            ctx.save();

            ctx.translate(this.contentLeft + (this.contentWidth / 2), this.contentTop + (this.contentHeight / 2));
            ctx.rotate((Math.PI / 180) * 20);
            ctx.translate(-(this.contentLeft + (this.contentWidth / 2)), -(this.contentTop + (this.contentHeight / 2)));

            ctx.moveTo(this.waypoints[0].x, this.waypoints[0].y);

            ctx.beginPath();
            ctx.globalCompositeOperation = "destination-out";
            ctx.fillStyle = '#000';

            this.progress = Math.min(this.progress + 1, this.waypoints.length - 1);
            for (let i = this.progress - 1; i > 0; i--) {
                let point = this.waypoints[i];
                let nextPoint = this.waypoints[i + 1];
                // ctx.lineTo(point.x, point.y);
                ctx.quadraticCurveTo(point.x, point.y, nextPoint.x, nextPoint.y);
            }
            ctx.stroke();
            ctx.restore();

            if (!forced) {
                this.progress++;
                if (this.progress < this.waypoints.length) {
                    requestAnimationFrame(() => this.render(forced));
                } else {
                    $(window).off("resize", this.updateSize);
                    this.$hero.find(".hero__text").addClass("hero__text--animating-in");
                    this.$hero.find(".hero__text-sub").addClass("hero__text-sub--animating-in");
                    this.$canvas.addClass("hero__canvas--animating-out");
                }
            }
        }
    }

    begin() {
        this.render(false);
    }

    getLineWidth() {
        return (this.contentWidth / HeaderSwipe.STROKE_COUNT) / 0.9;
    }

    getContentWidth() {
        let ctx = this.context;
        ctx.font = this.fontStyle;
        ctx.textBaseline = 'middle';
        ctx.textAlign = 'center';
        return ctx.measureText(this.$text.text()).width;
    }

    getContentHeight() {
        return this.$text.parent().outerHeight();
    }

    getContentLeft() {
        return (this.canvas.width / 2) - (this.getContentWidth() / 2);
    }

    getContentTop() {
        return this.$text.offset().top;
    }

    destroy() {
        $(window).off("resize", this.updateSize);

        this.context = null;
        this.canvas = null;
        this.$canvas = null;

        this.waypoints = [];
        this.vertices = [];
    }
}

HeaderSwipe.STROKE_COUNT = 5;
HeaderSwipe.WAYPOINT_COUNT = 14;

export default HeaderSwipe;
